// @ts-ignore
import SvgInjection from './SvgInjection.svelte';
export class SVGMap {
    constructor(onCommunityClick, onCommunityHover, onCommunityUnhover, mapType = "pact", defaultFocusColor = "#7F7F7F", svgObject, disableColor = "#d9d9d9", defaultHoverColor = "#D5E6F0", defaultStrokeColor = "#F7A833") {
        this.onCommunityClick = onCommunityClick;
        this.onCommunityHover = onCommunityHover;
        this.onCommunityUnhover = onCommunityUnhover;
        this.mapType = mapType;
        this.defaultFocusColor = defaultFocusColor;
        this.svgObject = svgObject;
        this.disableColor = disableColor;
        this.defaultHoverColor = defaultHoverColor;
        this.defaultStrokeColor = defaultStrokeColor;
        /**
         * The default background colors of the paths with the given id
         * @private
         */
        this.defaultColors = {};
        this.fillColors = {};
        this.communityQualifier = "path"; //or "g" for mega
        /**
         * The element that was clicked last.
         * This is used to unset it's background color when clicking another element
         */
        this.lastClicked = null;
        this.listeners = [];
        this.injectedElements = new SvgInjection({
            target: svgObject.contentDocument?.firstElementChild ?? null,
            anchor: svgObject.contentDocument?.firstElementChild?.firstElementChild ?? null
        });
        //  console.log("yy",{defaultStrokeColor:defaultStrokeColor, defaultHoverColor:defaultHoverColor,defaultFocusColor: defaultFocusColor});
        this.unsetSize();
        this.initEvents();
    }
    getHoverColor(value) {
        // console.log("getHoverColor: ", value);
        if (mapType == 'merged') {
            return this.defaultHoverColor;
        }
        const colorMap = {
            '#49B170': '#C2E1CE', //green
            '#56A8DD': '#D5E6F0', //blue
            'MIXED': 'url(#stripedPatternHover)' //mixed
        };
        return colorMap[value.toUpperCase()] || this.defaultHoverColor;
    }
    getStrokeColor(value) {
        if (mapType == 'merged') {
            return this.defaultStrokeColor;
        }
        const colorMap = {
            '#49B170': '#449161', //green
            '#56A8DD': '#428AB8', //blue
            'MIXED': '#428AB8' //mixed
        };
        return colorMap[value.toUpperCase()] || this.defaultStrokeColor;
    }
    resetLastClicked() {
        this.lastClicked = null;
    }
    resetFills() {
        if (this.lastClicked) {
            if (this.fillColors.hasOwnProperty(this.lastClicked.id)) {
                this.fillElement(this.lastClicked, this.fillColors[this.lastClicked.id]); //unhover filtered elem and not clicked
                //restore default:
            }
            else {
                this.fillElement(this.lastClicked, this.defaultColors[this.lastClicked.id]); //unhover and not clicked
            }
            this.lastClicked = null;
            setTimeout(() => {
            }, 100);
        }
        this.setFills({}, true);
    }
    setLastClicked(id) {
        //  console.log(":::setLastClicked() id= ", id);
        if (id != null && this.svgObject.contentDocument) {
            this.setLastClickedElem(this.svgObject.contentDocument.getElementById(id));
        }
    }
    setFills(pathFills, disablePath = false) {
        //console.log("defaultColors after setFills:");
        //console.log(this.defaultColors);
        if (disablePath) {
            this.iteratePaths(path => {
                //console.log("XX ITERATE for path = ", path.id);
                this.fillElement(path, null, false); //reset color and disable paths
                //this.defaultColors[path.id] = this.disableColor;
            });
        }
        else {
            this.defaultColors = pathFills;
            this.iteratePaths(path => {
                this.fillElement(path, pathFills[path.id], true);
            });
        }
    }
    markCommunities(markings) {
        /* not needed for mfi
            this.iteratePaths(path => {
                this.markElement(path, markings[path.id]);
            });

         */
    }
    /**
     * Fills the given communities with the given colors.
     * All other communities are filled with their default color (as specified in the backend by their region)
     * @param fills a map of community ids to fill colors
     */
    fillCommunities(fills) {
        this.fillColors = fills;
        this.iteratePaths(path => {
            const originalColor = fills[path.id] || this.defaultColors[path.id]; // || this.disableColor;
            // console.log(`:::originalColor for ${path.id} `,originalColor )
            this.fillElement(path, originalColor);
            //this will avoid errors for disabled communities:
            if (originalColor) {
                path.setAttribute('originalColor', originalColor); //save original color for border during onclick.
                //path.setAttribute('hoverColor', '#ff0000');
                path.setAttribute('hoverColor', this.getHoverColor(originalColor));
                path.setAttribute('focusStroke', this.getStrokeColor(originalColor));
                //console.log(":::getStrokeColor, -> = ", {id: path.id, original:originalColor, hover: path.getAttribute('hoverColor'), focus: this.getStrokeColor(originalColor)});
            }
        });
    }
    restoreCommunities() {
        // this.fillColors = fills;
        this.iteratePaths(path => {
            const originalColor = this.fillColors[path.id] || this.defaultColors[path.id] || this.disableColor;
            //console.log("restore", {id: path.id,color: originalColor})
            this.fillElement(path, originalColor);
        });
    }
    fillSearchResult(fills) {
        // this.fillColors = fills;
    }
    unsetSize() {
        if (this.svgObject.contentDocument == null || this.svgObject.contentDocument.firstElementChild == null)
            return;
        const svgElement = this.svgObject.contentDocument.firstElementChild;
        svgElement.removeAttribute("width");
        svgElement.removeAttribute("height");
    }
    //TODO helper for color result
    getColor(id) {
    }
    setLastClickedElem(path) {
        // console.log(":::set last clicked",path.id);
        // console.log(":::before clicked was -> ", this.lastClicked?.id)
        const currentUrl = new URL(window.location.href);
        let params = currentUrl.searchParams;
        if (path) {
            params.set('selectedCommunity', path?.id);
            const newUrl = currentUrl.toString();
            // console.log("yy new url = ", newUrl);
            window.history.pushState({}, '', newUrl);
            params = new URLSearchParams(window.location.search); // Re-fetch updated params
        }
        else {
            console.log('remove selecetedCommunity from url params');
            params.delete('selectedCommunity');
        }
        /*
                if(!path){
                    return;
                }

         */
        //remove last clicked element's styling
        if (this.lastClicked != null) {
            //this.markOutline(this.lastClicked, null);
            if (this.lastClicked != path) {
                const id = this.lastClicked.id;
                //restore filtered color:
                if (this.fillColors.hasOwnProperty(id)) {
                    // console.log(`fillColors[id] for ${id}:`,  this.fillColors[id])
                    this.fillElement(this.lastClicked, this.fillColors[id], false); //TODO CHECK!
                    //restore default:
                }
                else {
                    this.fillElement(this.lastClicked, this.defaultColors[id]);
                    //this.fillElement(this.lastClicked, this.defaultColors[this.lastClicked.id]);
                }
            }
        }
        else {
            // console.log("last clicked for first time");
            //this.fillElement(path, this.defaultColors[id]);
        }
        //style clicked element
        if (path == null)
            return;
        //this.markOutline(path, this.focusColor);
        //this.raise(path);
        this.lastClicked = path;
        //  console.log("last clicked is now = ", this.lastClicked.id);
        if (mapType == 'pact') {
            this.fillElement(path, path.getAttribute('hoverColor'), true); // hover
        }
        else if (mapType == 'merged') {
            //TODO
            this.fillElement(path, path.getAttribute('hoverColor'), true); // hover
        }
        else {
            this.fillElement(path, this.defaultFocusColor, true); // hover
        }
    }
    initEvents() {
        this.iteratePaths(path => {
            const id = path.id;
            const listeners = {
                path,
                click: () => {
                    if (path.getAttribute("disabled") == "true")
                        return;
                    this.setLastClickedElem(path); //not needed because Map.svelte is calling this already!
                    //old way:this.fillElement(path, this.focusColor,true); // hover
                    if (mapType == 'merged') {
                        let originalColor = this.fillColors[path.id];
                        // console.log("clicked, originalColor = ", originalColor);
                        this.fillElement(path, originalColor, true);
                    }
                    //fire event
                    this.onCommunityClick(id);
                },
                mousemove: (e) => {
                    if (path.getAttribute("disabled") == "true")
                        return;
                    //test
                    this.onCommunityHover(id, e);
                },
                mouseenter: (e) => {
                    /*
                                        console.log("last clicked = ");
                                        console.log(this.lastClicked);
                                        console.log('------------');
                    */
                    if (path.getAttribute("disabled") == "true")
                        return;
                    if (path != this.lastClicked) {
                        //console.log(":::mouse enter triggered for:", path);
                        //this.fillElement(path, this.defaultHoverColor); //
                        this.fillElement(path, path.getAttribute('hoverColor'));
                        //this.fillElement(path,this.getHoverColor())
                    }
                    //test
                    this.onCommunityHover(id, e);
                    // this.onCommunityHover(id);
                    //this.raise(path);
                    //this.markOutline(path, this.focusColor);
                    /*
                                        if (this.lastClicked) { // make sure the clicked one is always on top
                                            //this.raise(this.lastClicked);
                                            this.fillElement(path, this.focusColor); // hover

                                        }

                     */
                },
                mouseleave: () => {
                    //console.log("leave!!");
                    if (path.getAttribute("disabled") == "true")
                        return;
                    this.onCommunityUnhover(id);
                    if (path != this.lastClicked) {
                        //restore filtered color:
                        if (this.fillColors.hasOwnProperty(id)) {
                            this.fillElement(path, this.fillColors[id]); //unhover filtered elem and not clicked
                            //restore default:
                        }
                        else {
                            this.fillElement(path, this.defaultColors[id]); //unhover and not clicked
                        }
                    }
                    else {
                        //do nothing if hover over clicked element
                    }
                    //this.markOutline(path, null);
                }
            };
            path.addEventListener('click', listeners.click);
            path.addEventListener('mousemove', listeners.mousemove);
            path.addEventListener('mouseover', listeners.mouseenter);
            path.addEventListener('mouseout', listeners.mouseleave);
            this.listeners.push(listeners);
        });
    }
    destroy() {
        this.injectedElements.$destroy();
        for (const listener of this.listeners) {
            listener.path.removeEventListener('click', listener.click);
            listener.path.removeEventListener('mousemove', listener.mousemove);
            listener.path.removeEventListener('mouseenter', listener.mouseenter);
            listener.path.removeEventListener('mouseleave', listener.mouseleave);
        }
    }
    iteratePaths(iteratee) {
        if (this.svgObject == null || this.svgObject.contentDocument == null) {
            console.error("svg document is null", this.svgObject);
            return;
        }
        const paths = this.svgObject.contentDocument.getElementsByTagName("path");
        Array.from(paths).filter(p => p.id !== 'countryshape').forEach(path => {
            if (!path.id)
                return;
            iteratee(path);
        });
    }
    fillElement(element, fill, stroke = false, hover = false) {
        //console.log("XXX", {element,fill,stroke});
        //check if element is in filtered ist:
        //console.log("in filtered list??");
        /*
                if(this.fillColors.hasOwnProperty(element.id)){

                    element.style.fill = this.fillColors[element.id];
                    return;
                }
        */
        //	console.log("element:");
        //	console.log(element);
        //	console.log("--------------------");
        // let backgroundElements: SVGElement[] = []; // Array.from(element.querySelectorAll('.cls-6'))
        // .concat(Array.from(element.querySelectorAll('.st4'))) as SVGElement[]
        // if (element.id == "steinfort") //this one is special
        // 	backgroundElements = [element.children.item(0) as SVGElement, element.children.item(1) as SVGElement];
        // else
        // 	backgroundElements = [element.firstElementChild as SVGElement];
        const backgroundElements = [element]; //Array.from(element.querySelectorAll<SVGElement>('.cls-2'));
        //TODO: improve, this loop is always only for one element.
        for (let elem of backgroundElements) {
            // console.log(":::bla")
            if (fill != null) {
                if (element.id == 'ulflingen' || element.id == 'wiltz' || element.id == 'clerf') {
                    // console.log(":::TT", {id: element.id, fill: fill});
                }
                const originalFill = elem.getAttribute('originalColor');
                const focusStroke = elem.getAttribute('focusStroke');
                // console.log("originalFill = ", originalFill);
                elem.setAttribute("style", "cursor:pointer");
                elem.style.fill = fill == 'mixed' ? 'url(#stripedPattern)' : fill; // fill;
                // console.log("with stroke = ", stroke);
                if (stroke) {
                    //elem.style.stroke = '#56A8DD';
                    //elem.style.stroke = '#FF0000';
                    //	elem.style.stroke = '#ff0000';
                    //this.svgObject.contentDocument.
                    let backgroundPath = this.svgObject.contentDocument.querySelector('use#selected-state');
                    // console.log("current uses = ", backgroundPath);
                    if (backgroundPath) {
                        //	elem.style.stroke = '#ff0000';
                        if (originalFill == 'mixed') {
                            elem.style.stroke = '#56A8DD'; //check 428AB8
                            //	usePath.style.strokeDasharray ="5 5";
                        }
                        else {
                            elem.style.stroke = focusStroke; //originalFill;  //'#7F7F7F';
                        }
                        //elem.style.stroke =  '#7F7F7F';
                        elem.style.strokeWidth = "3";
                        // elem.style.filter = `drop-shadow(0px 1px 7px ${elem.style.stroke})`;
                        // Function to set xlink:href
                        const setXlinkHref = (useElement, href) => {
                            //useElement.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', href);
                            useElement.setAttribute('href', href);
                            //useElement.setAttribute('stroke','#ff0000');
                        };
                        setXlinkHref(backgroundPath, `#${element.id}`);
                        //   console.log("ready for ", element.id);
                        backgroundPath = this.svgObject.contentDocument.querySelector('use');
                        //  console.log("updated use =", backgroundPath)
                        //	usePath.style.stroke = '#ff0000';
                    }
                }
                else {
                    elem.style.strokeWidth = "2";
                }
            }
            else {
                elem.style.fill = this.disableColor;
                if (stroke) {
                    elem.style.stroke = '#7F7F7F';
                }
            }
            // elem.style.fill = '';
            element.setAttribute("disabled", String(fill == null));
        }
    }
    raise(element) {
        console.log("raise!!!");
        //const copy = Object.assign({}, element);
        //console.log(copy);
        const parent = element.parentElement;
        //element.remove();
        //	console.log("element:::");
        //	console.log(element);
        //parent.appendChild(element); //copy element
    }
    /** Makes the outline of the element big and uses the given color. If the color is null, the border is reset */
    markOutline(element, stroke) {
        let backgroundElements = [element];
        //let backgroundElements = Array.from(element.querySelectorAll<SVGElement>('.cls-border'));
        for (let elem of backgroundElements) {
            //elem.style.stroke = stroke;
            if (stroke) {
                //	elem.style.strokeWidth = '10px';// TODO: talk with Mads + Jan about stroke effect
            }
            else {
                elem.style.strokeWidth = '0px';
            }
        }
    }
    markElement(element, marking) {
        const fillElem = element.querySelector('.cls-fill');
        let markElem = element.querySelector('.cls-mark');
        if (!markElem && marking != null) {
            markElem = fillElem.cloneNode(true);
            markElem.classList.add('cls-mark');
            markElem.classList.remove('cls-fill');
            fillElem.after(markElem);
        }
        if (marking != null) {
            markElem.style.fill = `url(#${marking})`;
        }
        else if (markElem) {
            markElem.remove();
        }
    }
}
